import Head from "next/head";

interface HeadMetaProps {
  title?: string | null;
  description?: string | null;
  ogTitle?: string | null;
}

const HeadMeta = ({ title, description, ogTitle }: HeadMetaProps) => {
  return (
    <Head>
      <title>{title}</title>
      description && (
      <meta
        name="description"
        content={description as string}
        key="description"
      ></meta>
      =) ogTitle && (
      <meta property="og:title" content={ogTitle as string} key="title" />)
    </Head>
  );
};

export default HeadMeta;
